import axios from "axios";
import { clearUserData } from "../../redux/actions/user.dispatcher";

// export const BASE_URL = `${process.env.REACT_APP_PROD_API_URL}/api`;
export const BASE_URL = `${process.env.REACT_APP_STAGING_API_URL}/api`;
// export const BASE_URL = `http://192.168.18.3:3001/api`;

export const getToken = async () => {
  try {
    const token = await localStorage.getItem("authToken");

    return token;
  } catch (error) {
    console.error("Failed to retrieve the token from storage", error);
    return null;
  }
};

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let navigate;
let dispatch;

export const setFunctions = (navigateFunction, dispatchFunction) => {
  navigate = navigateFunction;
  dispatch = dispatchFunction;
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      if (dispatch) {
        dispatch(clearUserData());
      }

      localStorage.removeItem("authToken");

      window.location = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
